const EnumTipoDeRelacionamento = {
  1: 'Titular',
  2: 'Dependente',
  3: 'Responsável financeiro'
}

const EnumTipoUsuario = {
  T: 'Titular',
  D: 'Dependente',
  A: 'Agregado'
}

const EnumTipoDoContratante = {
  1: 'Beneficiario',
  2: 'Profissional de saúde',
  3: 'Empresa'
}

const EnumSituacaoBoleto = {
  pago: 'B',
  vencido: 'A',
  aberto: 'P'
}

const EnumTipoCobranca = {
  consignacao: 'C',
  boleto: 'B',
  debito: 'D'
}

export { EnumTipoDoContratante, EnumTipoDeRelacionamento, EnumTipoUsuario, EnumSituacaoBoleto, EnumTipoCobranca }
